export const formatNumberWithSeparator = (input: string | number): string => {
  const num = typeof input === 'string' ? parseFloat(input) : input;

  if (Number.isFinite(num)) {
    return num.toLocaleString();
  }

  return input.toString();
};
